<template>
  <div
    class="header"
    v-bind:class="{ pinned: scrolled, 'fixed-top': !logoShow }"
  >
    <nav class="navbar navbar-expand-lg navbar-dark container-fluid p-md-1 p-0">
      <router-link
        v-if="showMenuOptions"
        class="navbar-brand"
        :to="$t('routes.home')"
        @click.stop="hideMenu()"
      >
        <flix-latino-logo v-if="logoShow"></flix-latino-logo>
        <logo-f v-else />
      </router-link>
      <flix-latino-logo v-else></flix-latino-logo>
      <div
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <router-link
          v-if="!isLogged && logoShow && $route.name !== 'login'"
          class="logoutbutton mr-3"
          :to="$t('routes.login')"
          @click.stop="onLoginClick"
        >
          {{ $t("navbar.login") }}
        </router-link>

        <template v-if="isLogged">
          <button class="logoutbutton nav-button" type="button" @click.stop="logoutDirectly">
            {{ $t("navbar.logout") }}
          </button>
        </template>
        <icon-menu
          v-else-if="getFreemiumWorkflow === false"
          @click="toggleMenu()"
        ></icon-menu>
      </div>
      <div
        v-bind:class="{ show: show }"
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mr-auto tex">
          <li class="nav-item active tex" v-if="showCatalogLinks">
            <router-link
              class="nav-link"
              :to="$t('routes.movies')"
              @click.stop="hideMenu()"
            >
              {{ $t("navbar.logged.movies") }}
            </router-link>
          </li>
          <li class="nav-item active tex" v-if="showCatalogLinks">
            <router-link
              class="nav-link"
              :to="$t('routes.series')"
              @click.stop="hideMenu()"
            >
              {{ $t("navbar.logged.series") }}
            </router-link>
          </li>
          <li class="nav-item active tex" v-if="showCatalogLinks">
            <router-link
              class="nav-link"
              :to="liveRoute"
              @click.stop="hideMenu()"
            >
              {{ $t("navbar.logged.live") }}
            </router-link>
          </li>
          <li class="nav-item active tex" v-if="showCatalogLinks">
            <router-link
              class="nav-link"
              :to="$t('routes.discover')"
              @click.stop="hideMenu()"
            >
              {{ $t("navbar.discover") }}
            </router-link>
          </li>
          <li class="nav-item active tex" v-if="isLogged">
            <button
              class="text-white nav-link nav-button"
              type="button"
              @click="showMyList"
            >
              {{ $t("navbar.logged.my_list") }}
            </button>
          </li>
        </ul>
        <ul class="navbar-nav">
          <li class="nav-item nav-item--search">
            <router-link
              class="nav-link nav-link--search"
              :to="searchRoute"
              @click.stop="hideMenu()"
            >
              <icon-search />
              <span class="nav-link__label">{{ $t("search.search") }}</span>
            </router-link>
          </li>
          <li class="nav-item nav-item--cta" v-if="showCtaLink">
            <router-link
              class="nav-cta-link"
              :to="registerRoute"
              @click.stop="hideMenu()"
            >
              {{ ctaLabel }}
            </router-link>
          </li>
          <template v-if="isLogged">
            <li class="nav-item">
              <button
                @click.stop="logoutDirectly"
                class="nav-link text-right nav-button logout-menu-button"
                type="button"
              >
                <span class="float-down">{{ $t("navbar.logout") }}</span>
                {{ account.name ?? account.email }}
              </button>
            </li>
          </template>
          <template v-else>
            <li class="nav-item" v-if="$route.name !== 'login'">
              <router-link
                class="nav-link"
                :to="$t('routes.login')"
                @click.stop="onLoginClick"
              >
                {{ $t("navbar.login") }}
              </router-link>
            </li>
          </template>
          <li class="nav-item" v-if="!isLogged">
            <switch-language-component
              v-if="!isLogged"
              :small="true"
              class="w-100"
            />
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import FlixLatinoLogo from "../icons/flixLatinoLogo.vue";
import { mapActions, mapState } from "pinia";
import { UserStore } from "@/stores/userStore";
import IconMenu from "@/components/icons/iconMenu.vue";
import SwitchLanguageComponent from "@/components/forms/SwitchLanguageComponent.vue";
import LogoF from "@/components/icons/LogoF.vue";
import { SessionStore } from "@/stores/sessionStore";
import { UIStore } from "@/stores/uiStore";
import IconSearch from "@/components/icons/iconSearch.vue";

export default {
  name: "landing-header",
  components: {
    SwitchLanguageComponent,
    IconMenu,
    FlixLatinoLogo,
    LogoF,
    IconSearch,
  },
  data() {
    return {
      show: false,
      limitPosition: 500,
      scrolled: false,
      lastPosition: 0,
    };
  },
  methods: {
    onLoginClick() {
      this.hideMenu();
      this.$bus.emit("reloading", true);
    },
    ...mapActions(UIStore, ["setShowCreateAccountDialog"]),
    hideMenu() {
      this.show = false;
    },
    toggleMenu() {
      this.show = !this.show;
      console.log("Show menu:", this.show);
    },
    showMyList() {
      this.hideMenu();
      if (this.isLogged) {
        this.$router.push(this.$t("routes.my_list"));
        return;
      }

      this.setShowCreateAccountDialog(true);
    },
    logoutDirectly() {
      this.hideMenu();
      const userStore = UserStore();
      userStore.logout();

      if (typeof window !== "undefined") {
        window.location.replace(this.$t("routes.home"));
        return;
      }

      this.$router.push(this.$t("routes.home"));
    },
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
      }

      if (this.lastPosition > window.scrollY) {
        this.scrolled = false;
      }

      this.lastPosition = window.scrollY;
    },
  },
  computed: {
    ...mapState(UserStore, ["getAccount", "getToken", "getLanguage", "isPaidUser"]),
    ...mapState(SessionStore, ["getFreemiumWorkflow"]),
    showMenuOptions() {
      return this.$route.meta.hideMenuOptions === undefined;
    },
    logoShow() {
      return true;
    },
    isLogged() {
      return this.getToken !== null && this.getToken !== "";
    },
    account() {
      return this.getAccount;
    },
    liveRoute() {
      return {
        name: "live",
        params: { locale: this.$route.params.locale || this.getLanguage || "es" },
      };
    },
    searchRoute() {
      return {
        name: "search",
        params: { locale: this.$route.params.locale || this.getLanguage || "es" },
      };
    },
    registerRoute() {
      return this.$t("routes.register");
    },
    showCtaLink() {
      return !this.isLogged || !this.isPaidUser;
    },
    ctaLabel() {
      return this.isLogged
        ? this.$t("navbar.try_premium_free")
        : this.$t("navbar.start_free_trial");
    },
    showItems() {
      return !this.isLogged;
    },
    showCatalogLinks() {
      return this.$route.name !== "register";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors.scss";
@media (max-width: 959px) {
  .header {
  .nav-item--search {
    display: flex;
    align-items: center;
  }

  .nav-link--icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

    padding: 0 !important;
  }
}
.header {
  .nav-item--search {
    display: flex;
    align-items: center;
  }

  .nav-link--icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  padding: 0 4rem;
  &.pinned {
    position: fixed;
    top: 0;
    background-color: $dark-blue;
    width: 100vw;
    padding: 1em 0 0;
    z-index: 1000;
  }
  nav {
    .toptrial {
      margin: 0.8em 0;
    }
    .w-33 {
      width: 33px;
    }
    .w-48 {
      width: 48px;
    }
    .navbar-toggler {
      border: none;
      outline: none;
      .logoutbutton {
        color: #ffffff;
        font-size: 0.7em;
      }
    }
    padding: 2.35em;
    li.nav-item {
      margin: 0 0.5em;
      .float-down {
        position: absolute;
        margin-top: 1.7em;
        font-style: italic;
        font-size: 0.8em;
        color: $red;
      }
    }
    .dropdown-toggle::after {
      content: none;
    }
  }

  .navbar-collapse,
  .navbar-nav,
  .nav-item--cta {
    align-items: center;
  }

  .nav-item--cta {
    display: flex;
  }

  .navbar-nav .nav-link {
    text-decoration: none;
    text-underline-offset: 0.35em;
  }

  .nav-link--search {
    display: inline-flex;
    align-items: center;
    gap: 0.65rem;
  }

  .nav-link__label {
    display: none;
  }

  .nav-cta-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 38px;
    padding: 0.45rem 1.1rem;
    background: #d51f27;
    color: #ffffff !important;
    border-radius: 10px;
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.1;
    text-decoration: none;
    white-space: nowrap;
  }

  .nav-cta-link:hover,
  .nav-cta-link:focus-visible {
    color: #ffffff !important;
    text-decoration: none;
    background: #e32a32;
  }

  .navbar-nav .nav-link:hover,
  .navbar-nav .nav-link:focus-visible,
  .navbar-nav .router-link-active.nav-link,
  .navbar-nav .router-link-exact-active.nav-link {
    color: white;
    text-decoration: underline;
  }

  .nav-button {
    display: block;
    width: 100%;
    background: transparent;
    border: none;
    padding: 0.5rem 1rem;
    margin: 0;
    cursor: pointer;
    text-decoration: none;
    font: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    text-align: inherit;
    white-space: nowrap;
    -webkit-appearance: none;
    appearance: none;
  }

  @media (max-width: 959px) {
    nav {
      padding: 1em;
    }

    #navbarSupportedContent {
      backdrop-filter: blur(10px);
      position: fixed;
      top: 4em;
      width: 100%;
      height: 100%;
      left: 0;
      padding: 1em 2em;
      z-index: 1001;

      .nav-item {
        text-align: center;
        font-size: 1.5em;
        padding: 0.3em;

        .nav-link {
          display: flex;
          justify-content: center;
          width: 100%;
        }

        .nav-link--search {
          justify-content: center;
        }

        .nav-link--search :deep(svg) {
          width: 1em;
          height: 1em;
          flex: 0 0 1em;
        }
        .nav-link__label {
          display: inline;
        }

        .nav-cta-link {
          width: fit-content;
          min-width: 220px;
          min-height: auto;
          margin: 0 auto;
          padding: 0.5rem 1rem;
          font-size: inherit;
          font-weight: inherit;
          line-height: inherit;
        }

        &:active {
          a {
            border-radius: 0.5em;
            background-color: $washed-white;
          }
        }
      }
    }
  }
}
</style>
